import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/index'
import MapPage from '../components/map'
import MyPage from '../components/my'
import MonitorHaikangPage from '../components/monitor-haikang'
import Wxplayer from '../components/wxplayer'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {
            path: '/map',
            name: 'Map',
            component: MapPage
        },
        {
            path: '/my',
            name: 'My',
            component: MyPage
        },
        {
            path: '/monitor-haikang',
            name: 'MonitorHaikang',
            component: MonitorHaikangPage
        },
        {
            path: '/wxplayer',
            name: 'Wxplayer',
            component: Wxplayer
        }
    ]
})
